import { useMutation, useQueryClient } from "@tanstack/react-query";
import { payPointCredentialKeys } from "Api/Queries/PayPoints/usePayPointCredentialQuery";
import {
  type GatewayCredentialSecretResult,
  postPayPointsPublicIDCredential,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  payPointPublicID: string;
  onSuccess?: (result: GatewayCredentialSecretResult) => void;
  onError?: () => void;
};

export const useGenerateGatewayCredentialMutation = ({
  payPointPublicID,
  onSuccess,
  onError,
}: Props) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(() =>
      postPayPointsPublicIDCredential(payPointPublicID),
    ),
    onSuccess: (data: GatewayCredentialSecretResult) => {
      queryClient.invalidateQueries({
        queryKey: payPointCredentialKeys.byPayPointPublicId(payPointPublicID),
      });
      onSuccess?.(data);
    },
    onError,
  });
};
